import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, Input } from 'antd'

const Item = Form.Item

export default class CategoryEdit extends Component {

   // 基礎通用參數 ////////////////////////////////////////////// 

    static propTypes = {
        categoryName: PropTypes.string,
        modalform: PropTypes.func.isRequired
    }

    fm = React.createRef();
    UNSAFE_componentWillMount() {
        // 將form對象透過modalform()傳遞給父組件
        this.props.modalform(this.fm)
    }

    ////////////////////////////////////////////////////////////       

    render() {
        const { categoryName } = this.props
        return (
            <div>
                <Form ref={this.fm}>
                    <Item
                        label="分類名稱"
                        name="categoryName"
                        initialValue={categoryName}
                        rules={[
                            { required: true, whitespace: true, message: '必須輸入名稱' },
                        ]}
                    >
                        <Input placeholder='請輸入分類名稱' />
                    </Item>
                </Form>
            </div>
        )
    }
}